var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/**
 * O que a view do seletor de empresa desenha.
 *
 * Separado do presenter como em todo modulo: o scope e o contrato com a view, e o
 * presenter e quem o move.
 */
let CompanyOptionScope = class CompanyOptionScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '';
        this.current = false;
        /**
         * Uma segunda linha sob o nome da empresa, quando ha o que dizer dela.
         *
         * Hoje e a PROFISSAO que o profissional exerce naquela empresa - e no seletor que
         * "nutricionista aqui, preparadora fisica ali" fica visivel, porque as duas
         * aparecem uma debaixo da outra. Vazio para quem administra: ali a empresa nao
         * carrega papel nenhum.
         *
         * A empresa com o acesso bloqueado diz isso aqui tambem.
         */
        this.note = '';
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyOptionScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyOptionScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyOptionScope.prototype, "current", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyOptionScope.prototype, "note", void 0);
CompanyOptionScope = __decorate([
    Observable
], CompanyOptionScope);
export { CompanyOptionScope };
let CompanySelectorScope = class CompanySelectorScope extends Scope {
    constructor() {
        super(...arguments);
        /** O que o gatilho mostra: o nome da empresa escolhida, ou o `placeholder`. */
        this.summary = '';
        /** O rotulo acima do campo - so a forma de FILTRO o mostra. */
        this.label = '';
        /** O que aparece quando nada esta escolhido. */
        this.placeholder = 'Todas as Empresas';
        /** Se ha empresa escolhida - e o que faz aparecer o X de limpar. */
        this.hasSelection = false;
        /**
         * Se a escolha pode ser DESFEITA.
         *
         * Falso quando o conjunto e fechado - quem administra duas empresas escolhe entre
         * elas, e "nenhuma" nao e uma resposta: cada tela fala de UMA, e o servidor recusa
         * agir sem saber qual.
         */
        this.clearable = true;
        this.term = '';
        this.options = [];
        this.loading = false;
        /** Quantas casaram, para a tela dizer que ha mais do que cabe na lista. */
        this.total = 0;
        /** Conta as escritas PROGRAMATICAS no campo - ver `formRevision` em Meus Dados. */
        this.revision = 0;
        this.onTermChanged = Scope.SYNC_ACTION_STRING;
        /** Abrir a lista: e quando a primeira pagina e buscada. */
        this.onOpen = Scope.ASYNC_ACTION;
        /** O X ao lado do valor, que devolve o filtro ao estado "todas". */
        this.onClear = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanySelectorScope.prototype, "summary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanySelectorScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanySelectorScope.prototype, "placeholder", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanySelectorScope.prototype, "hasSelection", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanySelectorScope.prototype, "clearable", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanySelectorScope.prototype, "term", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanySelectorScope.prototype, "options", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanySelectorScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanySelectorScope.prototype, "total", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanySelectorScope.prototype, "revision", void 0);
CompanySelectorScope = __decorate([
    Observable
], CompanySelectorScope);
export { CompanySelectorScope };
//# sourceMappingURL=company-selector.scope.js.map